import { Box, SxProps, Theme } from '@mui/material'

import { UTILS } from '@/shared/constants'

interface MaterialSymbolIconProps {
  name: string
  className?: string
  size?: number
  weight?: number
  color?: string
  sx?: SxProps<Theme>
}

export default function MaterialSymbolIcon({
  name,
  className,
  size = 20,
  weight = 400,
  color = 'neutral.900',
  sx,
}: MaterialSymbolIconProps) {
  return (
    <Box
      component="span"
      className={`material-symbols-outlined${className ? ` ${className}` : UTILS.BLANK}`}
      sx={
        sx
          ? [
              {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'Material Symbols Outlined',
                fontSize: size,
                fontWeight: weight,
                fontVariationSettings: `'FILL' 0, 'wght' ${weight}, 'GRAD' 0, 'opsz' ${size}`,
                color,
                lineHeight: 1,
              },
              ...(Array.isArray(sx) ? sx : [sx]),
            ]
          : {
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontFamily: 'Material Symbols Outlined',
              fontSize: size,
              fontWeight: weight,
              fontVariationSettings: `'FILL' 0, 'wght' ${weight}, 'GRAD' 0, 'opsz' ${size}`,
              color,
              lineHeight: 1,
            }
      }
    >
      {name}
    </Box>
  )
}
